export function resolveAccountExportDom(page) {
    const form = page.querySelector('[data-account-export-form]');
    const trigger = page.querySelector('[data-account-export-trigger]');
    const feedback = page.querySelector('[data-account-export-feedback]');
    const availability = page.querySelector('[data-account-export-availability]');
    const card = page.querySelector('[data-account-export-card]');
    const exportUrl = String(page.dataset.accountExportUrl ?? '').trim();

    if (!(form instanceof HTMLElement)
        || !(trigger instanceof HTMLButtonElement)
        || !(feedback instanceof HTMLElement)
        || !(card instanceof HTMLElement)
        || exportUrl === '') {
        return null;
    }

    return {
        availability: availability instanceof HTMLElement ? availability : null,
        card,
        defaultTriggerLabel: trigger.textContent ?? 'Generate export',
        exportUrl,
        feedback,
        form,
        initialReadyDownloadUrl: String(card.dataset.accountExportReadyDownloadUrl ?? '').trim(),
        initialReadyExpiresAt: String(card.dataset.accountExportReadyExpiresAt ?? '').trim(),
        trigger,
    };
}
